import { defineComponent } from 'vue';
import { handleError } from '@/common/errors';

export default defineComponent({
  data() {
    return {
      error: '',
    };
  },

  methods: {
    handleError(error: unknown, customMessage: string) {
      this.error = handleError(error, customMessage);
    },
  },
});
